import get from 'lodash/get';
import noop from 'lodash/noop';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import {createEventHandler} from 'recompose';
import {buildInjector} from '../../../../_libs/angular-utils';
import fuse from '../../../../_libs/redux-fusion/index';
import {assetsStates} from '../../../../assets/router-config';
import {getId} from '../../../../core-utilities/domain/ReduxUtils';
import {persistEvent} from '../../../../core-utilities/react-utils';
import {ReduxListStreamedContainer} from '../../../../core-utilities/redux/ReduxListContainer';
import {projectStates} from '../../../../projects/router-config';
import {assetTasksStates} from '../../../../tasks/router-config';
import {stateGoBack, stateGoEnter, stateGoForward} from '../../../actions';
import {selectedAsset} from '../../../model/actions';
import {getProject} from '../../../model/reducers/state';
import {navStates} from '../../../router';
import {componentOptions, reduxList} from '../../redux/assetProjects';
import {buildProjectNavigationOptions} from '../../utils/itemActions';
import {AppNavigationAssetProjectsView} from './AppNavigationAssetProjectsView';


// Use legacy service to locally handle per-item requests, since they are allowed to occur in parallel
const dependencies = {};
export const injector = buildInjector(dependencies, [
  'rxPermissionsService',
]);

const StreamedComponent = (state$, dispatch) => (props$) => {
  const {
    onItemShowOptions: onShowProjectOptions,
  } = buildProjectNavigationOptions({
    dispatch,
    selectFirst: false,
  });
  const {
    handler: onClickOptions,
    stream: clickOptions$,
  } = createEventHandler();
  const selectThenNav = (project, navAction) => {
    dispatch(selectedAsset(get(project, 'asset.id')));
    dispatch(navAction);
  };
  const onClickBack = () => dispatch(stateGoBack({state: navStates.projectsList}));
  const onNavToManageAssets = () => dispatch(stateGoForward({state: projectStates.projectsManageAssets}));
  const onNavToOverview = (e, project) => selectThenNav(project, stateGoEnter({state: assetsStates.assetsHome}));
  const onNavToTasks = (e, project) => selectThenNav(project, stateGoEnter({state: assetTasksStates.tasks}));

  const project$ = state$
    .map(getProject)
    .distinctUntilChanged();

  clickOptions$
    .do(persistEvent)
    .withLatestFrom(project$)
    .debounceTime(300)
    .takeUntil(props$.last())
    .subscribe(([ev, project]) => {
      onShowProjectOptions(ev, project);
    });

  const permissions$ = observePermissions();

  return props$
    .combineLatest(
      project$,
      permissions$,
      (props, project, permissions) => ({
        ...props,
        projectName: get(project, 'name'),
        init: !!getId(project),
        parentId: getId(project),
        canManageAssets: permissions.canManageAssets,
        onClickBack,
        onClickOptions,
        onNavToManageAssets,
        onNavToOverview,
        onNavToTasks,
      }));
};

// The fuse container must inject the parentId into the ReduxListStreamedContainer
export const ListComponent = ReduxListStreamedContainer(AppNavigationAssetProjectsView, reduxList, componentOptions);
export const AppNavigationAssetProjectsContainer = fuse(StreamedComponent)(ListComponent);

function observePermissions() {
  const rxPermissionsService = dependencies.rxPermissionsService;
  return rxPermissionsService.userProjectRoleData$
    .map(rxPermissionsService.projectStateFn(getVIEW_ACTIONS))
    .startWith({permissions: {}, hasPermission: noop});
}

function getVIEW_ACTIONS(roleData) {
  const isLocked = roleData.projectIsLocked;
  return {
    canManageAssets: isLocked ? 'project_assets_create_locked' : 'project_assets_create',
    canDownloadFiles: 'task_fulfillments_view',
    canEdit: 'project_data_edit',
  };
}



// WEBPACK FOOTER //
// ./src/js/app/navigation/components/AppNavigationAssetProjects/AppNavigationAssetProjectsContainer.js